<template>
  <main class="content">
    <!-- content -->
    <section class="schedule-intro">
      <div class='container'>
        <div class="schedule-intro__wrapper">
          <h1 class="schedule-intro__title">Расписание занятий</h1>
        </div>
      </div>
    </section>
    <Shedule :timetable.sync="timetable" :hidetitle.sync="hidetitle"/>
    <section class="question schedule-intro-box">
      <div class='container'>
        <div class="question__wrapper">
          <div class="question__item">
            <h1 class="question__title">Как можно самому выиграть дело?</h1>
            <div class="question__text">
              <p>Вы - не юрист. Поэтому сотни наших юристов, которые учились и имеют большой опыт в решении конкретного вопроса, сделали всё за вас. Не важно, какой вам нужен результат: взыскать деньги, обанкротиться самостоятельно, выиграть спор по квартире, взыскать выплаты от работодателя, или добиться чего-то ещё - юристы уже всё сделали.</p>
              <p>Подготовим вас к суду, чтобы вы выиграли дело сами - без обращения к дорогим юристам и адвокатам.</p>
            </div>
          </div>

        </div>
      </div>
    </section>
  </main>
</template>

<script>
import axios from '@/router/http'
import moment from 'moment'
import Shedule from './include/shedule'

export default {
  name: 'table',
  components: {Shedule},
  data () {
    return {
      timetable: [],
      hidetitle: true
    }
  },
  mounted () {
    axios.get('https://smart.v-avtoservice.com/list/get-time-table').then(response => {
      this.timetable = response.data
    })
  },
  methods: {
    moment (date) {
      moment.lang('ru')
      return moment(date, 'YYYY-MM-DD HH:mm:ss').format('LL')
    },
    showModal (id, text, time) {
      this.$root.requestModal = id
      this.$root.requestModalText = text
      this.$root.requestModalTime = time
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/table.vue